"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortProviderNoUrl = void 0;
const tslib_1 = require("tslib");
const catalog_queries_1 = require("@tableau/catalog-queries");
const react_1 = tslib_1.__importDefault(require("react"));
class SortProviderNoUrl extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.updateOrder = (sortField) => {
            const validatedSortField = validateValue(sortField, this.props.validOrderFieldsWithDefaultDirections);
            if (validatedSortField === null) {
                return;
            }
            const newDirection = this.state.field === sortField
                ? this.state.direction === catalog_queries_1.OrderDirection.ASC ? catalog_queries_1.OrderDirection.DESC : catalog_queries_1.OrderDirection.ASC
                : this.props.validOrderFieldsWithDefaultDirections[validatedSortField] || catalog_queries_1.OrderDirection.ASC;
            this.setState({
                direction: newDirection,
                field: validatedSortField,
            });
        };
        this.state = {
            direction: this.props.validOrderFieldsWithDefaultDirections[this.props.defaultField],
            field: this.props.defaultField,
        };
    }
    render() {
        return this.props.children({
            orderBy: this.state,
            updateSortOrder: this.updateOrder,
        });
    }
}
exports.SortProviderNoUrl = SortProviderNoUrl;
function validateValue(value, validTypes) {
    // Because webclient types are not all uppercase, we can't normalize as in GraphQL-only types
    if (value in validTypes) {
        return value;
    }
    else {
        return null;
    }
}
//# sourceMappingURL=SortProviderNoUrl.js.map